/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchGraderSubmissionDataParser = 
/* #__PURE__ */ parsers.object([['userId', codecNumber, 'user_id']]);
export class PatchGraderSubmissionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchGraderSubmissionDataParser.decode(input).map(res => new PatchGraderSubmissionData(res));
    }
    static unsafeDecode(input) {
        return PatchGraderSubmissionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchGraderSubmissionDataParser.encode(data);
    }
    static schema() {
        return PatchGraderSubmissionDataParser.schema();
    }
}
